import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class FlightsComponent extends Vue {
    historyItems: flights.SearchHistoryItem[] = [];

    mounted() {
        window.document.title = i18next.t('title_flight_tickets');

        this.historyItems = new flights.FlightSearchService().getHistoryItems();
    }

    getClassName(classValue: string) {
        return flights.BookingClass.classLabel(classValue);
    }

    onHistoryItemClick(item: flights.SearchHistoryItem) {
        (<any>this).$ga.sendEvent('flights.form', 'history.select', 'flights.form.history.select');

        router.push('/flights' + item.url);
    }

    onHistoryClean() {
        new flights.FlightSearchService().deleteAllHistoryItems();
        this.historyItems = [];
    }

    onViewSearchHistoryClick() {
        (<any>this).$ga.sendEvent('flights.form', 'history.view', 'flights.form.history.view');
    }

    onSupportClick() {
        (<any>this).$ga.sendEvent('support.new', 'click', 'support.new.click');
        (<any>this).$ga.reachGoal('support.new.click');
        (<any>this).$ga.reachGoal('support.new.click.booking');
    }
}
